import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { Card, CardContent, Stack, Typography } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { InvestorAutocomplete } from "components/Autocompletes/InvestorAutocomplete";
import { useActionHook, useNavigate } from "hooks";
import { useCorrelationMatrixSettingsSelector, usePortfolioConstructionActions } from "store";

import { CorrelationMatrix } from "./Correlation-matrix/CorrelationMatrix";

export const Correlation: React.FC = () => {
  const { investor_id } = useParams<{ investor_id?: string }>();
  const investorId = investor_id ? Number(investor_id) : null;
  const navigate = useNavigate();

  const settings = useCorrelationMatrixSettingsSelector();
  const { getCorrelationDataAction, setCorrelationMatrixSettingsAction } = usePortfolioConstructionActions();

  const {
    action: getCorrelationData,
    data: correlationData,
    loading: correlationLoading
  } = useActionHook(getCorrelationDataAction);

  const handleInvestorChange = (value: { id: number; name: string } | null) => {
    setCorrelationMatrixSettingsAction({ ...settings, investor_id: value ? value.id : undefined });

    if (value) {
      navigate({ route: "benchmarkCorrelationInvestor", params: { investor_id: String(value.id) } });
    } else {
      navigate({ route: "benchmarkCorrelation" });
    }
  };

  useEffect(() => {
    // if (!investorId) return;
    getCorrelationData({ ...settings });
  }, [settings, getCorrelationData]);

  return (
    <Stack gap="16px" sx={{ flex: 1, minHeight: 0 }}>
      <Stack direction="row" alignItems="center" gap="12px">
        <Typography sx={{ fontSize: "14px", color: "#071f35", flexShrink: 0 }}>Investor</Typography>
        <InvestorAutocomplete
          dealInvestors={[]}
          showGrouped={false}
          preselectedInvestorId={investorId}
          onChange={handleInvestorChange}
          sx={{ maxWidth: 280 }}
        />
      </Stack>

      {investorId === null ? (
        <Card sx={{ boxShadow: "0 1px 2px 0 #1212171a", borderRadius: "8px", minHeight: 300 }}>
          <CardContent sx={{ padding: "16px" }}>
            <Stack sx={{ alignItems: "center", justifyContent: "center", py: "60px" }}>
              <Typography variant="h6" sx={{ color: "#496682", mb: "10px" }}>
                Correlation Analysis
              </Typography>
              <Typography sx={{ color: "#5d7782", textAlign: "center", maxWidth: "400px" }}>
                Select an investor to view correlation data.
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      ) : (
        <Card
          sx={{
            boxShadow: "0 1px 2px 0 #1212171a",
            borderRadius: "8px",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <AsyncContentMui isLoading={correlationLoading}>
            <CardContent
              sx={{ padding: "16px", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", height: "100%" }}
            >
              {correlationData ? (
                <CorrelationMatrix data={correlationData} investorId={investorId} />
              ) : (
                <Stack sx={{ alignItems: "center", justifyContent: "center", py: "60px" }}>
                  <Typography variant="h6" sx={{ color: "#496682", mb: "10px" }}>
                    Correlation Analysis
                  </Typography>
                  <Typography sx={{ color: "#5d7782", textAlign: "center", maxWidth: "400px" }}>
                    No correlation data available for this investor.
                  </Typography>
                </Stack>
              )}
            </CardContent>
          </AsyncContentMui>
        </Card>
      )}
    </Stack>
  );
};
